import React, { useState } from "react";
import EntityHeader from "./common/EntityHeader";
import Card from "react-bootstrap/Card";
import FieldDisplay from "./common/FieldDisplay";
import {
  getFieldDate,
  getFieldName,
  getFieldText,
} from "../scripts/helperScripts";
import ClientRateModal from "./common/ClientRateModal";

function ClientRateEntity({
  clientId,
  rates,
  clientProgram,
  fosterHomePrograms,
  modalities,
  updateModalities,
  updateRates,
  showExpired,
  currentRate,
  ...rest
}) {
  const [isOpen, setIsOpen] = useState(false);

  const hideModal = () => {
    setIsOpen(false);
  };

  const addNew = () => {
    setIsOpen(true);
  };
  return (
    <>
      {isOpen ? (
        <ClientRateModal
          isOpen={isOpen}
          hideModal={hideModal}
          clientId={clientId}
          clientProgram={clientProgram}
          fosterHomePrograms={fosterHomePrograms}
          modalities={modalities}
          updateModalities={updateModalities}
          updateRates={updateRates}
          currentRate={currentRate}
        ></ClientRateModal>
      ) : null}
      <EntityHeader
        {...rest}
        title="Client Rates"
        add={addNew}
        clientId={clientId}
        body={
          !showExpired && rates.length > 0
            ? [rates[0]].map((rate) => (
              <div key={rate.sor_fosterparentreimbursementid} className="p-2">
                <Card className="card-safy">
                  <Card.Header
                    className="p-0 ps-2 bg-safy1-1"
                    style={{ color: "white" }}
                  >
                    <div className="row">
                      <div className="col-10 ps-4 pt-1">{rate.sor_name}</div>
                      <div className="col-2"></div>
                    </div>
                  </Card.Header>
                  <Card.Body className="p-2 card-body-safy">
                    <FieldDisplay
                      label="Admin Rate"
                      value={parseFloat(
                        getFieldText(rate.sor_adminrate)
                      ).toFixed(2)}
                    />
                    <FieldDisplay
                      label="Billing Rate"
                      value={parseFloat(
                        getFieldText(rate.sor_billingrate)
                      ).toFixed(2)}
                    />
                    <FieldDisplay
                      label="Maintenance Rate"
                      value={parseFloat(
                        getFieldText(rate.sor_maintenancerate)
                      ).toFixed(2)}
                    />
                    <FieldDisplay
                      label="Reason for Update"
                      value={getFieldName(rate.sor_reasonforrateupdate)}
                    />
                    <FieldDisplay
                      label="Effective Date"
                      value={getFieldDate(rate.sor_effdate)}
                    />
                    <FieldDisplay
                      label="Created On"
                      value={getFieldDate(rate.createdon)}
                    />
                  </Card.Body>
                </Card>
              </div>
            ))
            : rates.map((rate, index) => (
              <div key={rate.sor_fosterparentreimbursementid} className="p-2">
                <Card className="card-safy">
                  <Card.Header
                    className="p-0 ps-2 bg-safy1-1"
                    style={{ color: "white" }}
                  >
                    <div className="row">
                      <div className="col-10 ps-4 pt-1">{rate.sor_name}</div>
                      <div className="col-2"></div>
                    </div>
                  </Card.Header>
                  <Card.Body
                    className={
                      index > 0 ? "p-2 bg-warning" : "p-2 card-body-safy"
                    }
                  >
                    <FieldDisplay
                      label="Admin Rate"
                      value={parseFloat(
                        getFieldText(rate.sor_adminrate)
                      ).toFixed(2)}
                    />
                    <FieldDisplay
                      label="Billing Rate"
                      value={parseFloat(
                        getFieldText(rate.sor_billingrate)
                      ).toFixed(2)}
                    />
                    <FieldDisplay
                      label="Maintenance Rate"
                      value={parseFloat(
                        getFieldText(rate.sor_maintenancerate)
                      ).toFixed(2)}
                    />
                    <FieldDisplay
                      label="Reason for Update"
                      value={getFieldName(rate.sor_reasonforrateupdate)}
                    />
                    <FieldDisplay
                      label="Effective Date"
                      value={getFieldDate(rate.sor_effdate)}
                    />
                    <FieldDisplay
                      label="Created On"
                      value={getFieldDate(rate.createdon)}
                    />
                  </Card.Body>
                </Card>
              </div>
            ))
        }
      />
    </>
  );
}

export default ClientRateEntity;
